var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpenGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.042 132.5C11.042 132.5 55.2087 44.167 132.5 44.167C209.792 44.167 253.959 132.5 253.959 132.5C253.959 132.5 209.792 220.834 132.5 220.834C55.2087 220.834 11.042 132.5 11.042 132.5Z",
    stroke: "#949494",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 165.625C150.794 165.625 165.625 150.794 165.625 132.5C165.625 114.206 150.794 99.375 132.5 99.375C114.206 99.375 99.375 114.206 99.375 132.5C99.375 150.794 114.206 165.625 132.5 165.625Z",
    stroke: "#949494",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenGray);
export default __webpack_public_path__ + "static/media/eye_open_gray.53feb6d70b7dfa73d81d91f0e3f4d95f.svg";
export { ForwardRef as ReactComponent };